<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M64.0018 103.922C86.0499 103.922 103.923 86.0481 103.923 64C103.923 41.9519 86.0499 24.0783 64.0018 24.0783C41.9536 24.0783 24.0801 41.9519 24.0801 64C24.0801 86.0481 41.9536 103.922 64.0018 103.922Z"
            class="primary-stroke"
            stroke-width="3.75944"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M41.9277 82.5198V59.2381L55.7124 45.4535L69.497 59.2381V82.5198H41.9277ZM45.6872 78.7603H53.4925V72.1097H57.9233V78.7603H65.7286V60.7777L55.7034 50.7525L45.6782 60.7777V78.7603H45.6872ZM53.4925 65.9424V61.5117H57.9233V65.9424H53.4925ZM74.0262 82.5466V57.3673L62.1123 45.4535H67.4382L77.7856 55.8009V82.5377H74.0262V82.5466ZM82.3149 82.5466V53.9301L73.8382 45.4535H79.182L86.0654 52.3637V82.5377H82.3059L82.3149 82.5466Z"
            class="primary-fill" />
    </svg>
</template>
